export default __webpack_public_path__ + "static/media/IMG_3732.5b2f79ef.jpeg";